import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeApplier } from "@/contexts/ThemeContext";
import AuthPage from "@/pages/AuthPage";
import PlannerPage from "@/pages/PlannerPage";
import ThemePage from "@/pages/ThemePage";
import ChecklistPage from "@/pages/ChecklistPage";
import LogPage from "@/pages/LogPage";
import VisionBoardPage from "@/pages/VisionBoardPage";
import LettersPage from "@/pages/LettersPage";
import SettingsPage from "@/pages/SettingsPage";
import ReviewPage from "@/pages/ReviewPage";
import AdminReviewsPage from "@/pages/AdminReviewsPage";
import AdminStatsPage from "@/pages/AdminStatsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import SundayResetPage from "@/pages/SundayResetPage";
import SundayResetHistoryPage from "@/pages/SundayResetHistoryPage";
import UpgradePage from "@/pages/UpgradePage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerificationBanner from "@/components/VerificationBanner";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return (
    <>
      <VerificationBanner />
      {children}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeApplier />
        <Toaster richColors position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <PlannerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/theme"
              element={
                <ProtectedRoute>
                  <ThemePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checklist"
              element={
                <ProtectedRoute>
                  <ChecklistPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/log"
              element={
                <ProtectedRoute>
                  <LogPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vision"
              element={
                <ProtectedRoute>
                  <VisionBoardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/letters"
              element={
                <ProtectedRoute>
                  <LettersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/review"
              element={
                <ProtectedRoute>
                  <ReviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/reviews"
              element={
                <ProtectedRoute>
                  <AdminReviewsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stats"
              element={
                <ProtectedRoute>
                  <AdminStatsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings/notifications"
              element={
                <ProtectedRoute>
                  <NotificationsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/sunday-reset"
              element={
                <ProtectedRoute>
                  <SundayResetPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sunday-reset/history"
              element={
                <ProtectedRoute>
                  <SundayResetHistoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upgrade"
              element={
                <ProtectedRoute>
                  <UpgradePage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
